import { Helmet } from '@dr.pogodin/react-helmet';
import { Route, Routes } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import CreditsAboutUs from './CreditsAboutUs';
import CreditsPage from './CreditsPage';
import CreditsUtils from './lib/CreditsUtils';

interface Props {
    lang: MultiLang;
}

const Credits = (props: Props) => {
    const { lang } = props;
    return (
        <>
            <Helmet>
                <title>
                    {CreditsUtils.getTitle(lang)} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <Routes>
                <Route index element={<CreditsAboutUs lang={lang} />} />
                <Route path=":id" element={<CreditsPage lang={lang} />} />
                <Route path="*" element={<PageNotFound lang={lang} />} />
            </Routes>
        </>
    );
};

export default Credits;
